import type { FunctionComponent } from 'react'
import { css } from '@emotion/css'
import styled from '@emotion/styled'
import { Text } from '@/tbui'
import TileSelect, { TileOption } from '../../TileSelect'

const StyledMenuTitle = styled.label`
  border-radius: ${({ theme }) => theme.shape.RADIUS_ALT};
  display: grid;
  font-size: 16px;
  min-height: 4.5rem;
  color: ${({ theme }) => theme.palette.TEXT};
  font-family: ${({ theme }) => theme.font.FAMILY_BOLD};
  align-items: center;
  justify-items: start;
  grid-template-areas:
    'title icon'
    'subtitle icon';
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  &.is-selected {
    background-color: ${({ theme }) => theme.palette.SECONDARY};
  }
  margin: 5px 0;
  padding: 16px;
`

const StyledMenuLabel = styled.span`
  color: ${({ theme }) => theme.palette.TEXT};
  grid-area: title;
  vertical-align: middle;
  width: 100%;
  word-break: break-all;
  &.is-selected {
    color: ${({ theme }) => theme.palette.TEXT_SECONDARY};
  }
`

const StyledMenuSubtitle = styled(Text)`
  grid-area: subtitle;
  color: ${({ theme }) => theme.palette.TEXT};
  font-weight: 400;
  font-size: 14px;
  margin-top: 0.5rem;
  &.is-selected {
    color: ${({ theme }) => theme.palette.TEXT_SECONDARY};
  }
`

const StyleTileSelectBody = css`
  max-height: calc(100vh - 76px);
  overflow: scroll;
`

interface MenuGroupDrawerSelectorProps {
  options: TileOption[]
  onChangeMenuGroup: (menuGroupID: string) => void
  selectedMenuGroupID: string
}

const MenuGroupDrawerSelector: FunctionComponent<MenuGroupDrawerSelectorProps> = ({
  options,
  selectedMenuGroupID,
  onChangeMenuGroup,
}) => {
  return (
    <TileSelect
      name="menu-group-drawer-selector"
      components={{
        Tile: StyledMenuTitle,
        Label: StyledMenuLabel,
        Subtitle: StyledMenuSubtitle,
      }}
      onChange={onChangeMenuGroup}
      stacked
      value={selectedMenuGroupID}
      options={options}
      className={StyleTileSelectBody}
    />
  )
}

export { MenuGroupDrawerSelector }
